import React, {PropTypes} from 'react';
import {Button, Icon} from '@goguardian/based';
import {Link} from 'react-router';
import cn from 'classnames';

import style from './style.scss';

export default class Navigate extends React.Component {

  render() {
    const chromeManagement = cn([style.chromeManagement], [style.imageWindow]);
    const deviceManagement = cn([style.deviceManagement], [style.imageWindow]);
    const userSettings = cn([style.userSettings], [style.imageWindow]);

    return (
      <div className={style.step}>
        <div className={style.stepHeader}>
          <Link to="/getting-started/sign-in"><Icon value="arrow-left"/></Link>

          <h1>Step 2 of 5</h1>
          <h2>Navigate</h2>
        </div>

        <div className={style.stepContent}>
          <div className={style.figureContent}>
            <p>Navigate to <br /> <strong>Device Management</strong>
              <Icon value="arrow-down"/>
            </p>
            <div className={style.figureContain}>
              <div className={deviceManagement}></div>
            </div>
          </div>

          <div className={style.figureContent}>
            <p>Select <br /> <strong>Chrome Management</strong>
              <Icon value="arrow-down"/>
            </p>
            <div className={style.figureContain}>
              <div className={chromeManagement}></div>
            </div>
          </div>

          <div className={style.figureContent}>
            <p>Click on <br /> <strong>User Settings</strong></p>
            <div className={style.figureContain}>
              <div className={userSettings}></div>
            </div>
          </div>

          <Link to="/getting-started/select"><Button block>Next</Button></Link>
        </div>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/gettingStarted/navigate/index.jsx
 **/